import { PermissionEnums } from '@yodlee/common-components/dist/types/enumerations';
import { widgetLoader } from "@yodlee/common-components/dist/utilities";
// import { ServiceRequest, UsersData } from "@yodlee/ycc-dashboard-widget";
import { NAV_TRIGGER_TYPE } from '../types/enumerations/service-request';
// import { NotificationWidget } from "@yodlee/ycc-status-widget";
import { IWidgetRegistration } from "../types/interfaces";
import { Permission } from '../types/interfaces/permission';
import { UrlConfigs } from "./";

const ServiceRequest = widgetLoader(() => import('@yodlee/ycc-dashboard-widget/dist/containers/service-requests'));
const UsersData = widgetLoader(() => import('@yodlee/ycc-dashboard-widget/dist/containers/users'));
const AverageRefreshTime = widgetLoader(() => import('@yodlee/ycc-dashboard-widget/dist/containers/average-refresh-time'));
const RefreshTimeBreakup = widgetLoader(() => import('@yodlee/ycc-dashboard-widget/dist/containers/refresh-time-breakup'));
const OverallHealthStatus = widgetLoader(() => import('@yodlee/ycc-dashboard-widget/dist/containers/overall-health-status'));
const RefreshTrend = widgetLoader(() => import('@yodlee/ycc-dashboard-widget/dist/containers/refresh-trend'));
const HighVolumePerformanceStats = widgetLoader(() => import('@yodlee/ycc-dashboard-widget/dist/containers/high-volume-performance-stats'));
const HightFailurePerformanceStats = widgetLoader(() => import('@yodlee/ycc-dashboard-widget/dist/containers/high-failure-performance-stats'));
const HighVolumeStats = widgetLoader(() => import('@yodlee/ycc-dashboard-widget/dist/containers/high-volume-stats'));
const HightFailureStats = widgetLoader(() => import('@yodlee/ycc-dashboard-widget/dist/containers/high-failure-stats'));


export const getWidgetRegistration = (history: any, permissions: Array<Permission>, hiddenWidgetKeys: Array<string>, isYodlee: boolean, isSIGraphsEnabled: boolean): Array<IWidgetRegistration.WidgetRegistration> => {
    let widgetRegistration: Array<IWidgetRegistration.WidgetRegistration> = [];
    const serviceRequestPermission = permissions!.find((permission) => permission.id === PermissionEnums.SERVICE_REQUESTS.ROOT);
    if (serviceRequestPermission) {
        widgetRegistration = [...widgetRegistration, {
            key: "SR",
            visible: !hiddenWidgetKeys.includes("SR"),
            name: "Service requests",
            widgetProps: {
                url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SERVICE_REQUESTS.url,
                onView: (serviceRequest: any) => {
                    history.push({
                        pathname: UrlConfigs.ROUTES.SUPPORT.subRoutes.SERVICE_REQUESTS.url,
                        // search: `?service-request-id=${serviceRequest.id}`,
                        state: { trigger: NAV_TRIGGER_TYPE.SR_WIDGET_TABLE, serviceRequestId: serviceRequest.id }
                    })
                },
                onCreate: () => {
                    history.push({
                        pathname: UrlConfigs.ROUTES.SUPPORT.subRoutes.SERVICE_REQUESTS.url,
                        state: { trigger: NAV_TRIGGER_TYPE.NEW_SR_CREATION }
                    })
                },
            },
            widget: ServiceRequest,
            isDefault: true,
        }];
    }

    if(isSIGraphsEnabled){
        widgetRegistration = [
            ...widgetRegistration,
            ...isYodlee ? [{
                key: "AVERAGE_REFRESH_TIME",
                visible: !hiddenWidgetKeys.includes("AVERAGE_REFRESH_TIME"),
                name: "Average site performance",
                widgetProps: {
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SITES.url
                },
                widget: AverageRefreshTime,
                isDefault: false,
                is2x: true
            }] : [], ...isYodlee ? [{
                key: "REFRESH_TIME_BREAKUP",
                visible: !hiddenWidgetKeys.includes("REFRESH_TIME_BREAKUP"),
                name: "Site performance breakup",
                widgetProps: {
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SITES.url
                },
                widget: RefreshTimeBreakup,
                isDefault: false,
                is2x: true
            }] : [], {
                key: "OVERALL_HEALTH_STATUS",
                visible: !hiddenWidgetKeys.includes("OVERALL_HEALTH_STATUS"),
                name: "Overall sites health",
                widgetProps: {
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SITES.url
                },
                widget: OverallHealthStatus,
                isDefault: false,
                is2x: true
            }, {
                key: "REFRESH_TEND",
                visible: !hiddenWidgetKeys.includes("REFRESH_TEND"),
                name: "Refresh health",
                widgetProps: {
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SITES.url
                },
                widget: RefreshTrend,
                isDefault: false,
                is2x: true
            }, ...isYodlee ? [{
                key: "HIGH_PERFORMANCE_STATS",
                visible: !hiddenWidgetKeys.includes("HIGH_PERFORMANCE_STATS"),
                name: "High volume sites performance",
                widgetProps: {
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SITES.url
                },
                widget: HighVolumePerformanceStats,
                isDefault: false,
                is2x: true
            }] : [], ...isYodlee ? [{
                key: "HIGH_FAILURE_PERFORMANCE_STATS",
                visible: !hiddenWidgetKeys.includes("HIGH_FAILURE_PERFORMANCE_STATS"),
                name: "High failure sites performance",
                widgetProps: {
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SITES.url
                },
                widget: HightFailurePerformanceStats,
                isDefault: false,
                is2x: true
            }] : [], {
                key: "HIGH_VOLUME_STATS",
                visible: !hiddenWidgetKeys.includes("HIGH_STATS"),
                name: "High volume sites",
                widgetProps: {
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SITES.url
                },
                widget: HighVolumeStats,
                isDefault: false,
                is2x: true
            }, {
                key: "HIGH_FAILURE_STATS",
                visible: !hiddenWidgetKeys.includes("HIGH_FAILURE_STATS"),
                name: "High failure sites",
                widgetProps: {
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SITES.url
                },
                widget: HightFailureStats,
                isDefault: false,
                is2x: true
            },
        ];    
    }
    return widgetRegistration;
}